// NOTE: This query replaces `savedAutoPayMethodQuery` from `@b-stock/fe-core`, which only
// returns `string | null` (the paymentMethodId). We need richer data (`paymentType`) to
// distinguish wire vs. digital on page load. Two follow-up options for a future iteration:
//   1. Remove `savedAutoPayMethodQuery` from fe-core if it is no longer used anywhere.
//   2. Promote this richer version into fe-core to make it available across portals.
import {
  getPaymentMethodsClient,
  makeAuthenticatedQuery,
} from '@b-stock/fe-core/bstock-next/queries'
import { buildAxiosRequestConfig } from '@b-stock/fe-core/bstock-react'
import type {
  AutoPayPaymentMethodPaymentTypeEnum,
  GetAutoPayMethodPayForTypeEnum,
} from '@b-stock/payments-methods-api-client'

export type SavedAutoPayData = {
  paymentMethodId?: string
  paymentType: AutoPayPaymentMethodPaymentTypeEnum
} | null

const getSavedAutoPay = async (
  accessToken: string,
  ownerEntityId: string,
  payForId: string,
  payForType: GetAutoPayMethodPayForTypeEnum
): Promise<SavedAutoPayData> => {
  const client = getPaymentMethodsClient()
  const response = await client.getAutoPayMethod(
    {
      ownerEntityId,
      payForId,
      payForType: payForType,
    },
    buildAxiosRequestConfig({ accessToken })
  )
  const first = response.data.paymentMethods[0]
  if (!first) return null
  return {
    paymentMethodId: first.paymentMethodId,
    paymentType: first.paymentType,
  }
}

// Query key prefix matches ['savedAutoPayMethod'] so existing invalidateQueries
// calls in the bid/buy-now confirm hooks continue to work without changes.
const savedAutoPayQuery = makeAuthenticatedQuery(
  'savedAutoPayMethod',
  getSavedAutoPay
)

export default savedAutoPayQuery
